import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { LocationsDropdown } from '../shared';
import { TextError } from '.';

export function SelectLocation(props) {
    const { label, name, milanStores, ...rest } = props;
    return (
        <div>
            {label && <label htmlFor={name}>{label}</label>}
            <Field as="select" id={name} name={name} {...rest} className="form-select">
                <LocationsDropdown milanStores={milanStores} />
            </Field>
            <ErrorMessage name={name} component={TextError} />
        </div>
    );
}

export default SelectLocation;
